import { useEffect, useState } from 'react'
import { deptDashboardApi } from '../services/api'

export interface DeptOption { id: string; name: string }
export interface DeptMemberStatus {
  userId: string; name: string; initials: string
  overdue: number; dueToday: number; doneToday: number; callsToday: number; meetingsToday: number; present: boolean
}
export interface DeptFailedTask {
  itemId: string; title: string; statusName: string
  assigneeName: string | null
  externalKey: string | null; externalUrl: string | null
  priority: string | null; issueType: string | null
  ageDays: number | null; reason: string | null
}
export interface DeptLeaveEntry {
  userId: string; name: string; avatarUrl: string | null
  type: string; startDate: string; endDate: string
}
export interface WorkloadRow {
  userId: string; name: string; initials: string; present: boolean
  load: number; done: number; calls: number; meetings: number; replies: number; voiceMin: number
}
export interface DeptDaySnapshot {
  deptId: string; deptName: string
  kpis: { overdue: number; dueToday: number; doneToday: number; eventsToday: number }
  members: DeptMemberStatus[]
  callDigest: Array<{ sessionId: string; title: string; startedAt: string; durationMin: number | null; participants: number }>
  failedTasks: DeptFailedTask[]
  onLeave: DeptLeaveEntry[]
  window: 'today' | 'week' | 'month'
  workload: WorkloadRow[]
}

export function useDepartments() {
  const [departments, setDepartments] = useState<DeptOption[]>([])
  useEffect(() => {
    let on = true
    deptDashboardApi.departments().then((r) => { if (on) setDepartments(r.data.departments ?? []) }).catch(() => {})
    return () => { on = false }
  }, [])
  return departments
}

export function useDashboardDept(deptId: string | null, window: 'today' | 'week' | 'month' = 'week') {
  const [snapshot, setSnapshot] = useState<DeptDaySnapshot | null>(null)
  const [loading, setLoading] = useState(false)
  useEffect(() => {
    if (!deptId) { setSnapshot(null); return }
    let on = true
    setLoading(true)
    deptDashboardApi.deptDay(deptId, window)
      .then((r) => { if (on) setSnapshot(r.data.snapshot ?? null) })
      .catch(() => { if (on) setSnapshot(null) })
      .finally(() => { if (on) setLoading(false) })
    return () => { on = false }
  }, [deptId, window])
  return { snapshot, loading }
}
